export default "__VITE_ASSET__dae86cac__"